<template>
  <div class="rounded-lg border-l-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      <div
        v-for="classification in classifications"
        :key="classification.label"
        class="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm"
      >
        <div
          :class="[
            classification.colors.circle,
            'w-7 h-7 rounded-full flex-shrink-0'
          ]"
        ></div>
        <div>
          <p
            class="text-xs font-bold"
            :class="textColorByLabel(classification.label)"
          >
            {{ classification.range }}
          </p>
          <p class="text-xs text-gray-600">{{ classification.label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REJECTION_CLASSIFICATION } from "@/components/views/mixins/agro_exporter/quality_reports/rejection_classification.js";

export default {
  name: "RejectionLegend",
  data() {
    return {
      classifications: REJECTION_CLASSIFICATION
    };
  },
  methods: {
    textColorByLabel(label) {
      const colorMap = {
        Excelente: "text-green-700",
        Bueno: "text-blue-700",
        Aceptable: "text-yellow-700",
        Precaución: "text-orange-700",
        Crítico: "text-red-700"
      };
      return colorMap[label] || "text-gray-700";
    }
  }
};
</script>
